import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ApiError } from '../api/client'
import { useAuth } from '../auth/AuthContext'
import { ErrorNote } from '../components/ui'

export function LoginPage() {
  const { login } = useAuth()
  const navigate = useNavigate()

  const [tenant, setTenant] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [mfaCode, setMfaCode] = useState('')
  const [mfaRequired, setMfaRequired] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [pending, setPending] = useState(false)

  const submit = async (event: React.FormEvent) => {
    event.preventDefault()
    setPending(true)
    setError(null)
    try {
      await login(tenant.trim(), email.trim(), password, mfaCode.trim() || undefined)
      navigate('/')
    } catch (err: unknown) {
      if (err instanceof ApiError && err.isMfaRequired) {
        // Не ошибка, а второй шаг: показываем поле кода и ждём ввод.
        setMfaRequired(true)
        setError(null)
      } else {
        setError(err instanceof ApiError ? err.message : String(err))
      }
    } finally {
      setPending(false)
    }
  }

  return (
    <div className="h-full flex items-center justify-center p-4 sm:p-6">
      <form onSubmit={submit} className="card w-full max-w-sm p-6 space-y-4">
        <div>
          <h1 className="text-lg font-semibold text-slate-100">Enterprise Alert Manager</h1>
          <p className="text-sm text-slate-500 mt-1">Вход в консоль дежурного</p>
        </div>

        <ErrorNote>{error}</ErrorNote>

        <div>
          <label className="label" htmlFor="tenant">
            Организация
          </label>
          <input
            id="tenant"
            className="input"
            value={tenant}
            onChange={(e) => setTenant(e.target.value)}
            placeholder="acme"
            autoComplete="organization"
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            className="input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="password">
            Пароль
          </label>
          <input
            id="password"
            type="password"
            className="input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        {mfaRequired && (
          <div>
            <label className="label" htmlFor="mfa">
              Код второго фактора
            </label>
            <input
              id="mfa"
              className="input font-mono tracking-widest"
              value={mfaCode}
              onChange={(e) => setMfaCode(e.target.value)}
              placeholder="123456"
              inputMode="numeric"
              autoFocus
              required
            />
            <p className="mt-1 text-xs text-slate-500">
              Подойдёт код из приложения-аутентификатора или один из резервных кодов.
            </p>
          </div>
        )}

        <button className="btn-primary w-full justify-center" disabled={pending}>
          {pending ? 'Проверяем…' : 'Войти'}
        </button>
      </form>
    </div>
  )
}
